/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayCount } from './DayCount';
import {
    DayCountFromJSON,
    DayCountFromJSONTyped,
    DayCountToJSON,
    DayCountToJSONTyped,
} from './DayCount';

/**
 * 
 * @export
 * @interface WeeklyActive
 */
export interface WeeklyActive {
    /**
     * 
     * @type {number}
     * @memberof WeeklyActive
     */
    total: number;
    /**
     * 
     * @type {Array<DayCount>}
     * @memberof WeeklyActive
     */
    by_day: Array<DayCount>;
}

/**
 * Check if a given object implements the WeeklyActive interface.
 */
export function instanceOfWeeklyActive(value: object): value is WeeklyActive {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('by_day' in value) || value['by_day'] === undefined) return false;
    return true;
}

export function WeeklyActiveFromJSON(json: any): WeeklyActive {
    return WeeklyActiveFromJSONTyped(json, false);
}

export function WeeklyActiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyActive {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'by_day': ((json['by_day'] as Array<any>).map(DayCountFromJSON)),
    };
}

export function WeeklyActiveToJSON(json: any): WeeklyActive {
    return WeeklyActiveToJSONTyped(json, false);
}

export function WeeklyActiveToJSONTyped(value?: WeeklyActive | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'by_day': ((value['by_day'] as Array<any>).map(DayCountToJSON)),
    };
}

